import { observer } from "mobx-react-lite";
import { MDSButton, MDSButtonGroup, MDSButtonVariant } from "@/mds";
import { DeleteNotePermanentlyModalStore } from "@/components/modal/delete-notes-permanently/delete-notes-permanently-modal-store";
import { pluralize } from "@/modules/pluralize";
import { INoteObservable } from "@/store/note";
import { TemplateObservable } from "@/store/templates/TemplateObservable";
import { useModalTitleLimit } from "@/components/modal/modal-title-limits/modal-title-limits";
import { MDSText, MDSTextVariant, MDSTextWeight, MDSDialogChip, MDSDialogChipVariant } from "@/mds";
import { MDSModalDialog, MDSDialogSlotName } from "@/mds/components/overlays/dialog";

export interface DeleteNotesPermanentlyModalProps {
  store: DeleteNotePermanentlyModalStore;
}

export const DeleteNotesPermanentlyModal = observer<DeleteNotesPermanentlyModalProps>(
  ({ store }) => {
    const primaryTitle = store.notes[0]?.title || "";
    const secondaryTitle = getSecondaryTitle(store.notes);
    const title = useModalTitleLimit({ primaryTitle, secondaryTitle, isAllShared: false });

    if (!store.notes.length) return null;

    return (
      <MDSModalDialog isOpen={store.isOpen} isDismissable handleClose={() => store.close()}>
        <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
          Delete <MDSDialogChip inline label={title} variant={MDSDialogChipVariant.Note} />{" "}
          {secondaryTitle}?
        </MDSText>
        <div slot={MDSDialogSlotName.Content}>
          <MDSText variant={MDSTextVariant.ParagraphS}>
            Make sure you want to permanently delete{" "}
            {store.notes.length > 1 ? "these notes" : "this note"}.{" "}
            <MDSText as="span" variant={MDSTextVariant.ParagraphS} weight={MDSTextWeight.SemiBold}>
              You cannot undo this action.
            </MDSText>
          </MDSText>
        </div>
        <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
          <MDSButton onClick={() => store.close()}>Cancel</MDSButton>
          <MDSButton variant={MDSButtonVariant.DangerFilled} onClick={() => store.handleSubmit()}>
            Delete forever
          </MDSButton>
        </MDSButtonGroup>
      </MDSModalDialog>
    );
  }
);

const getSecondaryTitle = (items: (INoteObservable | TemplateObservable)[]) => {
  if (items.length === 1) return "";
  return `and ${items.length - 1} other ${pluralize(items.length - 1, "note", "notes")}`;
};
